import App from '../../components/App';
import SymbolsStaticSection from '../../sections/static/Symbols';
import props from '../../configs/propsSymbolText';

export default function FontGenerator() {
  return (
    <App {...props}>
      <SymbolsStaticSection />
    </App>
  );
}
